import get from 'lodash/get'
import {
  getFeature,
  LoqateFeatures,
} from '@mindfulchefuk/helpers/js/getFeature'
import loqateEmailValidateDebounce, {
  Validate as loqateEmailValidate,
} from '@mindfulchefuk/services/loqate/EmailValidationInteractive/Validate'
import errorHandler from '@mindfulchefuk/utils/errorHandler'
import { logInvalidEmailEntered } from '@mindfulchefuk/features/Onboarding/utils/onboardingAnalytics'

const validateEmail = async (
  value: string,
  debounce = true
): Promise<boolean> => {
  const { email }: LoqateFeatures = getFeature('loqate')

  // If the feature is disabled return true
  if (email === 'false') return true

  let response

  // If the endpoint is down or invalid, continue without blocking
  try {
    const method = debounce ? loqateEmailValidateDebounce : loqateEmailValidate
    response = await method(value)
  } catch (error) {
    errorHandler(error, { suppress: true })
    return true
  }

  const { data } = response

  // If the endpoint returns an error continue without blocking
  if (get(data, 'Items[0].Error')) return true

  const responseCode = get(data, 'Items[0].ResponseCode', 'Invalid')

  if (responseCode === 'Invalid') {
    logInvalidEmailEntered()
  }

  return responseCode === 'Valid' || responseCode === 'Valid_CatchAll'
}

export default validateEmail
